import { Inline } from '@bedrock-layout/primitives'
import { ArticlepageHero } from '@okam/brand-ui'
import { useHtml2React } from '@okam/html2react/provider'
import { Typography, Date } from '@okam/shared-ui/index'
import { useTranslation } from 'next-i18next'
import tw from 'twin.macro' /* eslint-disable-line */
import { useFragment } from 'gql'
import type { MainMenuFragment, PostQuery, SiteOptionsQuery } from 'gql/graphql'
import { allMembersFragment } from 'query/fragments'
import { MainLayout } from '../../../components/layout/MainLayout'

export interface TPostQuery {
  pageProps: PostQuery & SiteOptionsQuery
}

export const Html2React = ({ content }: { content: string }) => {
  const { parseHTMLToReact } = useHtml2React()

  return (
    <Typography as="section" variant="p">
      {parseHTMLToReact(content)}
    </Typography>
  )
}

const PostPage = (props: TPostQuery) => {
  const { pageProps } = props
  const { post, siteOptions, mainMenu } = pageProps
  const allMembers = useFragment(allMembersFragment, pageProps.members)

  const { t } = useTranslation('common')

  const backTitleText = t('BUTTON.POSTS')
  const backTitleUri = `/${t('ROUTES.NEWS')}`
  const unkownTitle = t('UNKNOWN.TITLE')
  const unkownDate = t('UNKNOWN.DATE')

  return (
    <MainLayout
      siteOptionsProps={siteOptions}
      seo={post?.seo}
      allMembers={allMembers}
      menuItems={mainMenu as MainMenuFragment}
      variant="colored"
      translatedUri={post?.translatedUri}
    >
      <Inline
        justify="center"
        tw="flex flex-col h-full items-center pt-24 pb-10 lg:pt-28 lg:pb-16 xl:pt-32 px-6 mx-auto md:px-12 lg:px-14 w-full max-w-[1920px]"
      >
        <div tw="px-6 mx-auto md:px-12 lg:px-14 w-full max-w-[1920px]">
          <ArticlepageHero
            title={post?.title ?? unkownTitle}
            articleType={post?.categories?.nodes[0].name ?? ''}
            backLink={backTitleUri}
            backTitle={backTitleText}
          />
          <div tw="prose prose-woods max-w-prose mx-auto pt-12 pb-10 md:pb-14 lg:pt-18 lg:pb-20">
            <Date
              date={post?.date ?? unkownDate}
              dateFormat="long"
              tw=" text-[theme(colors.tertiary[4])]"
              variant="p"
            />
            <Html2React content={post?.content ?? ''} />
          </div>
        </div>
      </Inline>
    </MainLayout>
  )
}

export default PostPage
